(function () {
    "use strict";

    angular
        .module('iMatApp')
        .directive('slider', sliderDirective);

    sliderDirective.$inject = ['$log'];

    function sliderDirective($log) {
        var directive = {
            link: link,
            templateUrl: '/Scripts/iMatApp/views/sliderTemplate.html',
            restrict: 'A',
            scope: {
                inputValue: '=ngModel',
                minValue: '=',
                maxValue: '=',
                stepValue: '='
            }
        };

        return directive;

        // -----------------------------------------------------------------------------------

        function link(scope, element) {

            scope.percentageValue = calculateBarWidth;

            function calculateBarWidth() {
                var normalizedValue;

                if (angular.isFunction(scope.inputValue)) {
                    normalizedValue = scope.inputValue();
                } else {
                    normalizedValue = scope.inputValue;
                }

                var value = ((normalizedValue - scope.minValue) / (scope.maxValue - scope.minValue)) * 100;
                return value;
            }
        }
    }

})();